import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import HomeScreen2 from "../components/evento/HomeScreen2"
import { normalizarFiltro, coincideNombre } from "../utils/normalizarFiltro"

const AreaTematicaTemplate = ({ location, data, pageContext }) => {
  const { areaSlug, areaNombre } = pageContext
  const params =
    location && location.search ? new URLSearchParams(location.search) : null
  const areaParam = params && params.get("area") ? params.get("area").split("|") : []
  const tipoParam = params && params.get("tipo") ? params.get("tipo").split("|") : []
  const etiquetaParam =
    params && params.get("etiqueta") ? params.get("etiqueta").split("|") : []

  const areasTematicas = data.allStrapiAgendaMasterAreaTematica.edges.map(
    edge => edge.node
  )
  const tiposEvento = data.allStrapiAgendaMasterTipoEvento.edges.map(
    edge => edge.node
  )
  let eventos = data.allApiExternaEventosNext.edges.map(edge => edge.node)

  eventos = eventos.filter(evento =>
    (evento.area_tematicas || []).some(
      area => normalizarFiltro(area.Nombre) === areaSlug
    )
  )

  if (tipoParam.length > 0) {
    eventos = eventos.filter(
      evento =>
        evento.tipo_evento && coincideNombre(evento.tipo_evento.Nombre, tipoParam)
    )
  }

  if (areaParam.length > 0) {
    eventos = eventos.filter(evento =>
      (evento.area_tematicas || []).some(area =>
        coincideNombre(area.Nombre, areaParam)
      )
    )
  }

  if (etiquetaParam.length > 0) {
    eventos = eventos.filter(evento =>
      (evento.agenda_master_etiquetas || []).some(etiqueta =>
        coincideNombre(etiqueta.Nombre, etiquetaParam)
      )
    )
  }

  const resultData = {
    next: eventos,
    areasTematicas,
    tipoEvento: tiposEvento,
    areaNombre,
    variablesEntorno: {
      AGENDA_APP_SITE: data.site.siteMetadata.AGENDA_APP_SITE,
    },
    location,
  }

  return (
    <Layout>
      <SEO title={areaNombre || "PUCP"} pathname={`/${areaSlug}`} />
      <HomeScreen2 resultData={resultData} />
    </Layout>
  )
}

export default AreaTematicaTemplate

export const pageQuery = graphql`
  query AreaTematicaQuery {
    allStrapiAgendaMasterAreaTematica {
      edges {
        node {
          Nombre
          id
          strapiId
        }
      }
    }
    allStrapiAgendaMasterTipoEvento {
      edges {
        node {
          Nombre
          TipoEvento
          id
          strapiId
        }
      }
    }
    site {
      siteMetadata {
        title
        AGENDA_APP_SITE
      }
    }
    allApiExternaEventosNext(filter: { id: { ne: "dummy" } }) {
      edges {
        node {
          slug
          EventoDestacado
          ImagenDestacada {
            alternativeText
            alternative_id
            ext
            name
            mime
            height
            provider
            size
            url
            width
          }
          Titulo
          Fechas {
            Fecha
            Fin
            Inicio
            _xcomponent
            alternative_id
          }
          WorkFlow
          alternative_id
          area_tematicas {
            Nombre
            alternative_id
          }
          tipo_evento {
            Nombre
            TipoEvento
            alternative_id
          }
          id
          Lugar {
            DescripcionLink
            DescripcionLugar
            URL
            Ubicacion
            agenda_master_lugar_pucp {
              Nombre
              alternative_id
            }
            alternative_id
            _xcomponent
          }
          agenda_master_etiquetas {
            Nombre
            alternative_id
          }
        }
      }
    }
  }
`
